import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, MenuIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from '../ButtonLink';
import { ServicesMenu } from './ServicesMenu';
import { MobileMenu } from './MobileMenu';
import { useSiteHeader } from './useSiteHeader';
import { primaryNavLinks } from '../../data/navigation';
import { contact, images, urls } from '../../data/site';
export function SiteHeader() {
  const h = useSiteHeader();
  return <header className="sticky top-0 z-40 border-b border-line bg-paper" data-id="element-332" data-mp="luyjdwgs19g1">
      <div className="mx-auto flex h-[72px] max-w-[1320px] items-center justify-between gap-6 px-5 sm:px-8 lg:h-20 lg:px-12" data-id="element-333" data-mp="lx1hl3s328vu">
        <a href="/#top" className="shrink-0" aria-label="Motor City Truck Collision, home" data-id="element-334" data-mp="uwes7zry13i5">
          <img src={images.logo} alt="Motor City Truck Collision" className="h-10 w-auto max-w-[190px] object-contain lg:h-12 lg:max-w-[240px]" data-id="element-335" data-mp="2slxx8irjibf3" />
        </a>

        <nav aria-label="Primary" className="hidden lg:block" data-id="element-336" data-mp="39kfeenr9x3uw">
          <ul className="flex items-center gap-1 xl:gap-3" data-id="element-337" data-mp="39m0aiht8kuuv">
            <li ref={h.servicesWrapRef} className="relative" onBlur={h.handleServicesBlur} data-id="element-338" data-mp="34s5q1c5t4buq">
              <button ref={h.servicesButtonRef} type="button" aria-expanded={h.servicesOpen} aria-controls="services-menu" onClick={h.toggleServices} className={`inline-flex h-11 items-center gap-1.5 px-3 text-[15px] font-medium transition-colors duration-150 ease-out hover:text-brand-deep ${h.servicesOpen ? 'text-brand-deep' : 'text-ink'}`} data-id="element-339" data-mp="2zv5nhb861r8d">
                Services
                <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 transition-transform duration-200 ease-out ${h.servicesOpen ? 'rotate-180' : ''}`} data-id="element-340" data-mp="3dkzbjrbuk7h1" />
              </button>
              <AnimatePresence data-id="element-341" data-mp="228orqaf2zloq">
                {h.servicesOpen && <ServicesMenu id="services-menu" onNavigate={h.closeServices} data-id="element-342" data-mp="u7y6saajnhtw" />}
              </AnimatePresence>
            </li>
            {primaryNavLinks.map(link => <li key={link.href} data-id="element-343" data-mp="k98le7jfvf8w">
                <a href={link.href} className="inline-flex h-11 items-center px-3 text-[15px] font-medium text-ink transition-colors duration-150 ease-out hover:text-brand-deep" data-id="element-344" data-mp="k7xliit46rn2">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-345" data-mp="1i7qpvpcq5v5">
          <ButtonLink href={urls.quote} className="hidden h-11 px-5 text-[17px] sm:inline-flex md:h-11 md:px-5" data-id="element-346" data-mp="1jiqzljl8vhi">
            Request a Quote
          </ButtonLink>
          <a href={contact.phoneHref} aria-label={`Call ${contact.phoneDisplay}`} className="inline-flex h-11 w-11 items-center justify-center border border-line text-ink lg:hidden" data-id="element-347" data-mp="3noxkmu51fryo">
            <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-348" data-mp="393ibswfb7kow" />
          </a>
          <button ref={h.mobileButtonRef} type="button" aria-expanded={h.mobileOpen} aria-controls="mobile-menu" aria-label="Open menu" onClick={h.openMobile} className="inline-flex h-11 w-11 items-center justify-center bg-ink text-paper lg:hidden" data-id="element-349" data-mp="351x4dqljnym3">
            <MenuIcon aria-hidden="true" className="h-5 w-5" data-id="element-350" data-mp="3rzs1yi3hk1p9" />
          </button>
        </div>
      </div>

      <MobileMenu open={h.mobileOpen} onClose={h.closeMobile} onNavigate={h.navigateFromMobile} data-id="element-351" data-mp="3nxwxx5u67a7s" />
    </header>;
}